var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { staticClass: "item-row po-item-row" }, [
    _c("td", { attrs: { colspan: "4" } }, [
      _c("table", { staticClass: "full-width" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [
              _c(
                "div",
                { staticClass: "sort-icon-wrapper handle" },
                [
                  _vm.POHasItems
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectFieldItem,
                            expression: "selectFieldItem",
                          },
                        ],
                        attrs: { id: _vm.item.systemItemId, type: "checkbox" },
                        domProps: {
                          value: _vm.item.systemItemId,
                          checked: Array.isArray(_vm.selectFieldItem)
                            ? _vm._i(
                                _vm.selectFieldItem,
                                _vm.item.systemItemId
                              ) > -1
                            : _vm.selectFieldItem,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.selectFieldItem,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = _vm.item.systemItemId,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.selectFieldItem = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.selectFieldItem = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.selectFieldItem = $$c
                            }
                          },
                        },
                      })
                    : _c("font-awesome-icon", {
                        staticClass: "sort-icon",
                        attrs: { icon: "grip-vertical" },
                      }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("td", {}, [
              _c(
                "div",
                { staticClass: "item-select-wrapper" },
                [
                  _c("item-select-through-name", {
                    ref: "itemSelect",
                    attrs: {
                      invalid: _vm.$v.item.name.$error,
                      "invalid-description": _vm.$v.item.description.$error,
                      item: _vm.item,
                      index: _vm.index,
                      "tax-per-item": _vm.taxPerItem,
                      taxes: _vm.item.taxes,
                    },
                    on: {
                      search: _vm.searchVal,
                      select: _vm.onSelectItem,
                      deselect: _vm.deselectItem,
                      onDesriptionInput: function ($event) {
                        return _vm.$v.item.description.$touch()
                      },
                      onSelectItem: function ($event) {
                        _vm.isSelected = true
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("item-select-through-part-number", {
                  ref: "itemSelect",
                  attrs: {
                    invalid: _vm.$v.item.name.$error,
                    "invalid-description": _vm.$v.item.description.$error,
                    item: _vm.item,
                    index: _vm.index,
                    "tax-per-item": _vm.taxPerItem,
                    taxes: _vm.item.taxes,
                  },
                  on: {
                    search: _vm.searchVal,
                    select: _vm.onSelectItem,
                    deselect: _vm.deselectItem,
                    onDesriptionInput: function ($event) {
                      return _vm.$v.item.description.$touch()
                    },
                    onSelectItem: function ($event) {
                      _vm.isSelected = true
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "td",
              { staticClass: "text-left" },
              [
                _c("base-input", {
                  attrs: {
                    invalid: _vm.$v.item.quantity.$error,
                    type: "text",
                    small: "",
                  },
                  on: {
                    keyup: function ($event) {
                      return _vm.updateItem(_vm.item, _vm.index)
                    },
                    input: function ($event) {
                      return _vm.$v.item.quantity.$touch()
                    },
                  },
                  model: {
                    value: _vm.item.quantity,
                    callback: function ($$v) {
                      _vm.$set(_vm.item, "quantity", $$v)
                    },
                    expression: "item.quantity",
                  },
                }),
                _vm._v(" "),
                _vm.$v.item.quantity.$error
                  ? _c("div", [
                      !_vm.$v.item.quantity.maxLength
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(_vm.$t("validation.quantity_maxlength"))
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _c("div", { staticClass: "item-amount" }, [
                _c(
                  "div",
                  { staticClass: "remove-icon-wrapper" },
                  [
                    _vm.isShowRemoveItemIcon
                      ? _c("font-awesome-icon", {
                          staticClass: "remove-icon",
                          attrs: { icon: "trash-alt" },
                          on: {
                            click: function ($event) {
                              return _vm.removeItem(_vm.item, _vm.index)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "2%" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "35%" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "35%" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "10%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }